import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, MapPin, Star } from "lucide-react";
import CoachAvatar from "@/components/CoachAvatar";
import VerifiedBadge from "@/components/VerifiedBadge";

export default function SuggestedCoaches() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/suggestions/coaches").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.coaches.length === 0) return null;
  return (
    <div className="mt-10" data-testid="suggested-coaches">
      <h2 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Sparkles className="w-6 h-6 text-orange-500" /> Coachs suggérés pour vous</h2>
      <p className="text-sm text-slate-600 mt-1">Basé sur vos séances {data.based_on?.disciplines?.length ? `de ${data.based_on.disciplines.join(", ")}` : ""}{data.based_on?.room ? ` près de ${data.based_on.room}` : ""}.</p>
      <div className="mt-4 grid sm:grid-cols-3 gap-3">
        {data.coaches.map((c) => (
          <Link key={c.id} to={`/coachs/${c.id}`} data-testid={`suggested-coach-${c.id}`} className="sc-card flex gap-3 items-start hover:ring-2 hover:ring-orange-300 transition">
            <CoachAvatar coach={c} size="w-12 h-12" textSize="text-base" />
            <div className="min-w-0">
              <div className="font-bold text-slate-900 truncate">{c.name}</div>
              <div className="text-xs text-slate-500 flex items-center gap-1"><MapPin className="w-3 h-3" />{c.city || "—"}{c.distance_km != null && ` · ${c.distance_km} km`}{c.rating_avg != null && <span className="flex items-center gap-0.5 text-orange-600 ml-1"><Star className="w-3 h-3" />{c.rating_avg}</span>}</div>
              <div className="mt-1 flex flex-wrap gap-1">{(c.specialties || []).slice(0, 3).map((s) => <span key={s} className={`text-[10px] px-1.5 py-0.5 rounded-full border ${c.matches_discipline && data.based_on.disciplines.map((d) => d.toLowerCase()).includes(s.toLowerCase()) ? "bg-orange-500 text-white border-orange-500" : "bg-orange-500/10 text-orange-700 border-orange-500/20"}`}>{s}</span>)}</div>
              <div className="mt-1"><VerifiedBadge coach={c} /></div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
